<template>
  <v-col md="4">
    <v-card class="neu-glow">
      <v-row class="mx-0 pa-4" justify="space-between" align="center">
        <!-- title and subtitle -->
        <div>
          <div class="text-h6 float-left mr-1" v-text="$t('Dashboard.headingOperational')"></div>
          <div class="text-h6 float-left">: {{formattedAmount(this.user.d_charts.TotProfits[0])}}</div>
        </div>
        <!-- Stats -->
        <div class="d-flex flex-column align-end">
          <v-bottom-navigation
            v-model="showingTasks"
            color="secondary"
            class="neu-glow with-radius"
            height="40"
          >
            <v-btn value="View All" to='./reports/profit_loss'>
              <span v-text="$t('Dashboard.viewAll')"></span>
            </v-btn>
          </v-bottom-navigation>
        </div>
      </v-row>
      <v-card-text class="py-0">
        <line-chart v-if="data"
            :data="buildChart"
            :options="settings.line_option"
            :style="{ height: '300px' }"
            class="pt-5"
            id='Chart'
        />
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
import { mapGetters } from "vuex";
import colors from "vuetify/lib/util/colors";
import LineChart from "@/components/ChartJS/LineChart";
export default {
  components: { LineChart },
  computed : {
    ...mapGetters(["user","settings","formattedTimeframe","formattedAmount","formattedNumber"]),
    buildChart(){
      this.data.labels = this.user.d_charts.labels_chart;
      this.data.datasets=[];
      let enabled=['Profits'];
      enabled.forEach( e =>
      {                  
        if (this.user.d_charts[e])
        {
          if (this.user.d_charts[e].reduce((a, b) => a + b, 0)!=0) 
          {
            let lc={"Profits":[colors.mygreen.lighten2, colors.mygreen.lighten2],"Purchases":[colors.red.base, colors.red.accent3],"walmart":[colors.blue.base, colors.blue.accent3],"rakuten":[colors.orange.base, colors.orange.accent4],"total":[colors.red.base, colors.red.accent4]};
            this.settings.line_empty_dataset.label=e;//e.charAt(0).toUpperCase() + e.slice;
            this.settings.line_empty_dataset.data = this.user.d_charts[e];
            this.settings.line_empty_dataset.gradientStroke= lc[e];
            this.data.datasets.push(JSON.parse(JSON.stringify(this.settings.line_empty_dataset)));
          }
        }
      });
      return this.data;
    },
  },
  data() {
    return {
      namespace: "Dashboard",
      page: "Operational Profit",
      loading:false,
      errorid: null,
      showingTasks: "View All",
      data: 
      {
        labels: null,
        datasets: null
      },
    };
  },
  methods:
  {
    beforeDestroy() {
      this.chartProperties = null;
      delete this.chartProperties;
    },
  }
}
</script>